import { BASE_URL } from "../../../utils/requestUtils";

export interface PublicConsentRequestBody {
  public_id: string;
  first_name: string;
  last_name: string;
  date_of_birth: string; // YYYY-MM-DD
  is_nipt_screen_consent: boolean;
}

export const submitPublicConsent = async (
  body: PublicConsentRequestBody,
): Promise<number> => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/account_patient_consent/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    );

    return response.status;
  } catch (e) {
    return 501;
  }
};
